import React, { useContext, useState, useEffect } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Loaders from '../../../../molecules/Loaders'
import CustomSearch from '../../../../molecules/CustomSearch'
import CustomTable from '../../../../molecules/CustomTable'
import SettingContext from '../../../../../context/setting/settingContext'
import PropTypes from 'prop-types'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import UserEmailLogs from './UserEmailLogs'
import UserSmsLogs from './UserSmsLogs'

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const UserLogs = (props) => {
    const settingcontext = useContext(SettingContext)
    const [value, setValue] = useState(0)

    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const [isLoading, setIsLoading] = useState(true)

    const data = props.data
    const toggleFullScreenPopup = props.function

    const [tableBody, setTableBody] = useState([])

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                user_id: {
                    value: 0,
                    type: 'in',
                    field: 'uls.user_id',
                },
            },
            primaryTable: 'user_logins',
        },
        onSubmit: (values) => {
            setIsLoading(true)
            searchTableFetch(values, 'user_logins')
        },
    })

    useEffect(() => {
        console.log('dataCheck', data)
        // if (data.status === 'loginHistory') {
        setTableBody([])
        setIsLoading(true)
        formik.values.filters.user_id.value = data.id
        formik.values.page = 1
        searchTableFetch(formik.values, 'user_logins')
        // }
        // return () => {
        //     setTableBody([])
        // }
    }, [data.id])

    useEffect(() => {
        return () => setIsLoading(false)
    }, [])

    useEffect(() => {
        if (search_fetch_data) {
            console.log(search_fetch_data.from, 'frommm')
            if (search_fetch_data.from === 'user_logins') {
                console.log(search_fetch_data.records, 'inside coming or not')
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
                console.log('search_fetch_data', search_fetch_data)
                setIsLoading(false)
            }
        }
    }, [search_fetch_data])

    const tableValues = []

    tableValues.push({
        field: 'id',
        type: '',
        firstChild: true,
        sort: true,
        sortField: 'id',
        disablePadding: false,
        label: 'ID',
    })

    tableValues.push(
        {
            field: 'useragent',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'User Agent',
        },
        {
            field: 'ip',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'IP Address',
        }
    )

    tableValues.push({
        field: 'created_at',
        type: 'datetime',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Login date',
    })

    const tableActions = []

    console.log('tableBody', tableBody)
    const searchInfo = null

    const handleChange = (newValue) => {
        setValue(newValue)
    }
    return (
        <>
            <div className="">
                <div className="innerTabs">
                    <AppBar position="static">
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="buyer dashboard"
                        >
                            <Tab
                                label="Login Info"
                                {...a11yProps(0)}
                                onClick={() => handleChange(0)}
                            />
                            <Tab
                                label="Email Logs"
                                {...a11yProps(1)}
                                onClick={() => handleChange(1)}
                            />
                            <Tab
                                label="SMS Logs"
                                {...a11yProps(2)}
                                onClick={() => handleChange(2)}
                            />
                        </Tabs>
                    </AppBar>
                    <TabPanel value={value} index={0}>
                        {isLoading ? (
                            <Loaders name="table" isLoading={isLoading} />
                        ) : (
                            <CustomTable
                                formik={formik.values}
                                tableBody={tableBody}
                                tableValues={tableValues}
                                tableActions={tableActions}
                                allData={search_fetch_data}
                                changeTableFunction={searchTableFetch}
                                hideCompactView={true}
                                fromVariable={'user_logins'}
                            />
                        )}
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <UserEmailLogs
                            userId={props.userId}
                            hideCompactView={true}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <UserSmsLogs
                            userId={props.userId}
                            hideCompactView={true}
                        />
                    </TabPanel>
                </div>
            </div>
        </>
    )
}

export default UserLogs
